import "./App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { BrandingProvider } from "./context/BrandingContext";
import Layout from "./components/Layout";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import POS from "./pages/POS";
import SalesHistory from "./pages/SalesHistory";
import Categories from "./pages/Categories";
import SubCategories from "./pages/SubCategories";
import Products from "./pages/Products";
import StockMovements from "./pages/StockMovements";
import Equipment from "./pages/Equipment";
import Agenda from "./pages/Agenda";
import CalendarPage from "./pages/CalendarPage";
import Appointments from "./pages/Appointments";
import Customers from "./pages/Customers";
import Suppliers from "./pages/Suppliers";
import { IncomePage, ExpensePage } from "./pages/IncomeExpense";
import Cash from "./pages/Cash";
import Reports from "./pages/Reports";
import Users from "./pages/Users";
import Permissions from "./pages/Permissions";
import Settings from "./pages/Settings";
import AuditLog from "./pages/AuditLog";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === undefined)
    return (
      <div className="flex h-screen items-center justify-center bg-[#F9FAFB]">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-[#0B1F3A] border-t-[#D4AF37]" />
      </div>
    );
  if (user === null) return <Navigate to="/giris" replace />;
  return <Layout>{children}</Layout>;
};

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrandingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/giris" element={<Login />} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/satis" element={<Protected><POS /></Protected>} />
              <Route path="/satis-gecmisi" element={<Protected><SalesHistory /></Protected>} />
              <Route path="/ana-kategoriler" element={<Protected><Categories /></Protected>} />
              <Route path="/alt-kategoriler" element={<Protected><SubCategories /></Protected>} />
              <Route path="/urunler" element={<Protected><Products /></Protected>} />
              <Route path="/stok-hareketleri" element={<Protected><StockMovements /></Protected>} />
              <Route path="/envanter" element={<Protected><Equipment /></Protected>} />
              <Route path="/ajanda" element={<Protected><Agenda /></Protected>} />
              <Route path="/takvim" element={<Protected><CalendarPage /></Protected>} />
              <Route path="/randevular" element={<Protected><Appointments /></Protected>} />
              <Route path="/musteriler" element={<Protected><Customers /></Protected>} />
              <Route path="/tedarikciler" element={<Protected><Suppliers /></Protected>} />
              <Route path="/gelir" element={<Protected><IncomePage /></Protected>} />
              <Route path="/gider" element={<Protected><ExpensePage /></Protected>} />
              <Route path="/kasa" element={<Protected><Cash /></Protected>} />
              <Route path="/raporlar" element={<Protected><Reports /></Protected>} />
              <Route path="/kullanicilar" element={<Protected><Users /></Protected>} />
              <Route path="/yetkilendirme" element={<Protected><Permissions /></Protected>} />
              <Route path="/ayarlar" element={<Protected><Settings /></Protected>} />
              <Route path="/denetim-kayitlari" element={<Protected><AuditLog /></Protected>} />
            </Routes>
          </BrowserRouter>
        </BrandingProvider>
      </AuthProvider>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
